module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiCnIt.c2403d6.eot";